import { HeroBlock } from './HeroBlock';
import './LeftPanel.css';

export function LeftPanel() {
    return (
        <div className="d5-left">
            <HeroBlock />
        </div>
    );
}
